<template functional>
  <label class="new-form-checkbox" :class="[data.staticClass]">
    <input
      :indeterminate.prop="props.indeterminate"
      :checked="props.checked"
      :disabled="props.disabled"
      :value="props.value"
      v-bind="data.attrs"
      type="checkbox"
      v-on="listeners"
    />
    <span class="control-wrapper">
      <span v-if="props.label" class="checkbox-label">{{ props.label }}</span>
    </span>
  </label>
</template>

<script>
export default {
  name: "NewFormCheckbox",
  props: {
    label: {
      type: String,
      default: ""
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>
